export function addCurrent(status) {
    return {
        type: 'ADD_CURRENT',
        status,
    }
}
